import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faChevronDown, faChevronUp, faTrash } from '@fortawesome/free-solid-svg-icons';

import CustomButton from '../../Componentization/CustomButton';
import CustomText from '../../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../../store';

import useSecureStorage from '../../../hooks/useSecureStorage';
import useQssWalletAddress, { QssWalletAddress } from '../../../hooks/useQssWalletAddress';

import i18next from 'i18next'

import WebApp from '@twa-dev/sdk'

import PinCodeScreen from '../../Authentication/PinCodeScreen';

/**
 * @brief QSS 지갑주소 관리 페이지 스크린
 * @returns 
 */
const QssSettingWalletAddressScreen = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const { getBlockChain } = useSecureStorage()
	const { getQssWalletAddress, 
			removeQssWalletAddress,
			editNameQssWalletAddress } = useQssWalletAddress()

	const [isDeleteModalVisible, setDeleteModalVisible] = useState(false)
	const [showPinCodeAuth, setShowPinCodeAuth] = useState(false)
	const [qssWalletAddressList, setQssWalletAddressList] = useState<QssWalletAddress[]>([]);
	const [selNetworkName, setSelNetworkName] = useState('')
	const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

	let qSSIndex = -1;

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "QssSettingWalletAddressScreen", "title": t('stack_header_message_24') }))
	}, [])

	useEffect(() => {
		const getQssWalletList = async () => {
            // QSS 지갑주소 리스트
			const network = await getBlockChain()
            const qssWalletList = await getQssWalletAddress(network)
            // console.log(`QssSettingAddressScreen qss 저장된 지갑주소 리스트`, qssWalletList)

            if(false === qssWalletList.result) {
				// QSS에 저장된 지갑주소 데이터가 없음
				console.log(`QSS에 저장된 지갑주소 정보 없음`)
			} else {
				// QSS에 저장된 지갑주소 데이터가 있음
                // console.log(`QSS에 저장된 지갑주소 정보 있음 Value : `, qssWalletList.value)
				if(null != qssWalletList.value) {
					const value:QssWalletAddress[] = qssWalletList.value
					setQssWalletAddressList(value)
				}
			}

			// 현제 선택된 네트워크
			const selNetwork = await getBlockChain()
			if(null == selNetwork || '' === selNetwork) {
				setSelNetworkName(process.env.REACT_APP_NETWORK_NAME!)
			}
			else {
				setSelNetworkName(selNetwork)
			}
			// TEST 임시 qSS 전체 clear
			// console.log(`QSS 전체 Clear`)
			// await clearQssWalletAddress();
		}

		// testAddQssWalletAddress()
		getQssWalletList()
	}, [])

	const handleItemPress = async (screen: string) => {
		if (screen) {
			navigate(`/${screen}`, { replace: true, state: {} });
		}
	}
	// QSS 지갑주소 추가 페이지로 이동
	const handleNewQssWalletAddress = async () => {
		navigate(`/QssSettingWalletAddressAdd`);
	}

	const handleQssEditWalletName = async (index: number) => {
		qSSIndex = index;
        WebApp.showConfirm(t('qss_setting_wallet_add_message_13'), TgWebAppUpdateWalletNameCallBack)
    }

	const TgWebAppUpdateWalletNameCallBack = async (isSuccess: boolean) => {
		if (true !== isSuccess) {
            return
        }

        let index = qSSIndex
        qSSIndex = -1
        try {
            // 변경한 니모닉이름 저장
            if (index >= 0 && index < qssWalletAddressList.length) {
                const newName = qssWalletAddressList[index]
                await editNameQssWalletAddress(newName.name, index, selNetworkName)
            }
        } catch (error) {
            console.warn(`Error Qss Load Data`, error);
        }
	}

	// 지갑주소 이름 입력 변경
    const updateWalletName = (index: number, newName: string) => {
        setQssWalletAddressList((prevList) => {
            const updatedList = [...prevList];
            updatedList[index] = { ...updatedList[index], name: newName };
            return updatedList;
        });
    };

	const handleQssDelWalletAddress = async (index: number) => {        
		qSSIndex = index;
        WebApp.showConfirm(t('qss_setting_wallet_add_message_14'), TgWebAppDelWalletAddressCallBack)
    }

	const TgWebAppDelWalletAddressCallBack = async (isSuccess: boolean) => {
		if (true !== isSuccess) {
            return
        }

        let index = qSSIndex
        qSSIndex = -1
        try {
            const selectWallet: QssWalletAddress = qssWalletAddressList[index]
			console.log(`DelQssWallet selectWallet : `, selectWallet)

            if (null != selectWallet.address && '' !== selectWallet.address) {
                // 니모닉코드, 네트워크
                const trimmedAddress = selectWallet.address.trim()
                const networkName = selectWallet.network

				console.log(`DelQssWallet trimmedAddress : `, trimmedAddress)
				console.log(`DelQssWallet networkName : `, networkName)

                const removeResult = await removeQssWalletAddress(networkName, trimmedAddress)
                if (true === removeResult) {
                    WebApp.showPopup({ message: t('qss_setting_wallet_add_message_15') })

                    // qSS 지갑주소 다시 불러와 리스트 갱신
					const network = await getBlockChain()
                    const qssWalletList = await getQssWalletAddress(network)
                    console.log(`TgWebAppDelMnemonicCallBack QssSettingDataList qss 저장된 니모닉 리스트`, qssWalletList)
                    console.log(`qssMnemonic.result : ${qssWalletList.result}`)
                    console.log(`qssMnemonic.value.length : ${qssWalletList.value.length}`)

                    if (true === qssWalletList.result) {
                        if (0 < qssWalletList.value.length) {
                            setQssWalletAddressList(qssWalletList.value)
                        } else {
                            // qss 니모닉 usestate 초기화
                            setQssWalletAddressList([])
                        }
                    } else {
                        alert('qss setting wallet address load error')
                    }
                } else {

                }
            }

        } catch (error) {
            console.warn(`Error Qss Wallet Address Load Data`, error);
        }
	}

    // qSS 지갑 전체 삭제
	const handleQssClearPress = async () => {
	}

    // qss 비밀번호 확인 성공
	const handleQssPasswordAuthSuccess = async (pin: string) => {
    }

	// 펼침처리
	const handleToggleExpand = (index: number) => {
		if (expandedIndex === index) {
		  setExpandedIndex(null); // 펼침 상태 해제
		} else {
		  setExpandedIndex(index); // 특정 인덱스를 펼침 상태로 설정
		}
	};

	const styles = {
		container: {
			padding: "60px 5px 24px",
			position: "relative"
		} as React.CSSProperties,
		sectionTitleTop: {
			fontSize: 14,
			color: theme.text_15,
			width: "100%",
			paddingTop: "10px",
			paddingBottom: "10px",
			paddingLeft: "10px",
			paddingRight: "24px",
			boxSizing: "border-box"
		} as React.CSSProperties,
		sectionTitle: {
			fontSize: 14,
			color: theme.text_15,
			width: "100%",
			paddingTop: "20px",
			paddingBottom: "10px",
			paddingLeft: "10px",
			paddingRight: "24px",
			boxSizing: "border-box"
		} as React.CSSProperties,
		groupContainer: {
			borderRadius: 10,
			marginVertical: 8,
			overflow: 'hidden',
			padding: "0 15px",
		} as React.CSSProperties,
		item: {
			display: "flex",
			alignItems: 'center',
			justifyContent: "space-between",
			padding: "19px",
			paddingLeft: "10px",
			borderBottom: `1px solid ${theme.border_04}`,
			cursor: "pointer"
		} as React.CSSProperties,
		itemText: {
			fontSize: 16,
			paddingRight: "10px",
			color: theme.text_15,
			flex: 1
		} as React.CSSProperties,
		extraText: {
			color: theme.text_08,
			marginRight: 8
		} as React.CSSProperties,
		arrowIcon: {
			width: 13,
			height: 21,
			tintColor: theme.text_03
		} as React.CSSProperties,
		topRounded: {
			borderTopLeftRadius: 10,
			borderTopRightRadius: 10,
		} as React.CSSProperties,
		bottomRounded: {
			borderBottomLeftRadius: 10,
			borderBottomRightRadius: 10,
			borderBottom: `0px solid ${theme.border_04}`
		} as React.CSSProperties,
		deleteText: {
			color: theme.text_17
		} as React.CSSProperties,
		modalBackground: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: theme.background_alternative,
			position: "absolute",
			width: "100%",
			height: "100%",
			top: 0,
			left: 0
		} as React.CSSProperties,
		modalContainer: {
			width: '90%',
			backgroundColor: 'white',
			borderRadius: 10,
			padding: '20px',
			border: `1px solid ${theme.border_09}`,
			boxSizing: "border-box"
		} as React.CSSProperties,
		modalTitle: {
			fontSize: 18,
			color: theme.text_17,
			textAlign: 'center',
			marginBottom: 10
		} as React.CSSProperties,
		modalMessage: {
			fontSize: 14,
			color: theme.text_02,
			textAlign: 'center'
		} as React.CSSProperties,
		modalButtons: {
			display: "flex",
			width: '100%',
			borderTop: `1px solid ${theme.border_10}`,
			marginTop: 20
		} as React.CSSProperties,
		cancelButton: {
			width: "100%",
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			padding: "10px 0",
			borderRight: `1px solid ${theme.border_10}`,
		} as React.CSSProperties,
		cancelButtonText: {
			color: theme.text_15,
			fontSize: 16
		} as React.CSSProperties,
		confirmButton: {
			width: "100%",
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
		} as React.CSSProperties,
		confirmButtonText: {
			color: theme.text_17,
			fontSize: 18
		} as React.CSSProperties,
		buttonPrimary: {
            backgroundColor: theme.button_02,
            padding: '12px',
            borderRadius: '10px',
            marginTop: '12px',
			marginBottom: '12px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            height: '54px',
            justifyContent: 'center',
        } as React.CSSProperties,
        buttonPrimaryText: {
            color: theme.static_white,
            fontSize: '16px',
            textAlign: 'center', // textAlignVertical은 웹에서는 textAlign으로 처리
        } as React.CSSProperties,
		transactionItem: {
            // display: "flex",
            alignItems: 'center',
			justifyContent: "space-between",
            padding: "13px 15px",
            borderRadius: 10,
            marginBottom: 10,
            border: `1px solid ${theme.line_neutral}`
        } as React.CSSProperties,
        transactionDetails: {
            // flex: 1
        } as React.CSSProperties,
        transactionName: {
            fontSize: 15
        } as React.CSSProperties,
        transactionAmountContainer: {
            display: "flex",
            alignItems: 'center'
        } as React.CSSProperties,
        xIcon: {
            width: 15,
            height: 15
        } as React.CSSProperties,
		deleteButton: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
        } as React.CSSProperties,
		inputWalletAddress: {
            width: "100%",
			flex: 1,
            borderTop: "none",
            borderRight: "none",
            borderLeft: "none",
            borderBottom: "none",
            outline: "none",
            fontSize: 16,
            height: "30px",
            background: "inherit"
        } as React.CSSProperties,
		walletAddressListContainer: {
			// padding: "5px",
			// height: "500px",
			height: "calc(100vh - 198px)",
			overflow: "auto"
		} as React.CSSProperties,
	}

	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_01 }}>
            {/* QSS 지갑주소 리스트 표시 */}
            <div style={{ width: "100%" }}>
                <CustomText style={{ ...styles.sectionTitleTop, color: theme.text_05 }}>
					{/* 현재 지갑에 선택된 네트워크 */}
					{selNetworkName.toUpperCase()}
                </CustomText>
				<div className='containerScroll' style={{ ...styles.walletAddressListContainer }}>
                    {qssWalletAddressList.map((item, index) => (
						item.network.toLowerCase() === selNetworkName.toLowerCase() && ( // 조건 추가
							
							<div key={index} style={{ ...styles.transactionItem, backgroundColor: theme.fill_normal }}>
								{/* <CustomText style={{ ...styles.itemText, color: theme.text_01 }}>{item.network}</CustomText> */}
								<div style={{ display: "flex", marginBottom: "10px"}}>
									<div style={styles.transactionDetails}>
										{/* <span style={{ ...styles.transactionName, color: theme.label_strong }}> */}
											<input
												key={index}
												value={item.name}
												onChange={(e) => updateWalletName(index, e.target.value)}
												placeholder={i18next.t('qss_setting_wallet_add_message_12')}
												style={{
													...styles.inputWalletAddress,
													borderBottom: `1px solid ${theme.line_alternative}`,
													color: theme.label_strong,
												}}
											/>
										{/* </span> */}
									</div>
									{expandedIndex === index && (
										<>
											<FontAwesomeIcon icon={faFloppyDisk} color={theme.text_01} style={{ fontSize: '25px', marginLeft: '10px', marginRight: '10px' }} onClick={() => handleQssEditWalletName(index)} />
											<FontAwesomeIcon icon={faTrash} color={theme.text_01} style={{ fontSize: '25px', marginLeft: '10px', marginRight: '10px' }} onClick={() => handleQssDelWalletAddress(index)} />
											<FontAwesomeIcon icon={faChevronUp} color={theme.text_01} style={{ fontSize: '25px', marginLeft: '10px', marginRight: '10px' }} onClick={() => handleToggleExpand(index)} />
										</>
									)}
									{expandedIndex !== index && (
										<>
											<FontAwesomeIcon icon={faFloppyDisk} color={theme.text_13} style={{ fontSize: '25px', marginLeft: '10px', marginRight: '10px' }}  />
											<FontAwesomeIcon icon={faTrash} color={theme.text_13} style={{ fontSize: '25px', marginLeft: '10px', marginRight: '10px' }} />
											<FontAwesomeIcon icon={faChevronDown} color={theme.text_13} style={{ fontSize: '25px', marginLeft: '10px', marginRight: '10px' }} onClick={() => handleToggleExpand(index)} />
										</>
									)}
								</div>
								{expandedIndex === index && (
								<> 
									<div style={{ display: "flex", wordBreak: "break-all", }}>
										<CustomText style={{ color: theme.text_05 }}>
											{item.address}
										</CustomText>	
									</div>
								</>
								)}
							</div>


						)
                    ))}

					{/* 현재 네트워크와 일치하는 QSS 지갑주소 수량 체크 */}
					{0 === qssWalletAddressList.filter(
						(item) => item.network.toLowerCase() === selNetworkName.toLowerCase()).length && 
					(
						<div
							key={1}
							style={{
								...styles.item,
								borderColor: theme.divider_background_03,
								backgroundColor: theme.divider_background_02,
								...styles.topRounded,
								...styles.bottomRounded,
							}}
							onClick={() => {}}
						>
							<CustomText style={{ ...styles.itemText, color: theme.text_01 }}>
								{t('qss_setting_wallet_screen_message_02')}
							</CustomText>
						</div>
                    )}
                </div>

                {/* QSS 지갑주소 저장 버튼 */}
                {/* <CustomText style={{ ...styles.sectionTitleTop, color: theme.text_05 }}>
                    {t('qss_setting_wallet_screen_message_03')}
                </CustomText> */}
                {/* <div style={{ ...styles.groupContainer, backgroundColor: theme.divider_background_02 }}> */}
                    <CustomButton
                        containerStyle={{
                            ...styles.buttonPrimary, // 기존 스타일
                            backgroundColor: theme.primary_normal, // 추가 스타일
                        }}
                        textStyle={{ ...styles.buttonPrimaryText }}
                        onPress={() => { handleNewQssWalletAddress() }}
                        text={t('qss_setting_wallet_screen_message_04')}
                        withBackground={true}
                        backgroundColor={theme.background_08}
                    />
                {/* </div> */}
            </div>
			
			{
				isDeleteModalVisible && (
					<div style={styles.modalBackground}>
						<div style={{ ...styles.modalContainer, backgroundColor: theme.modal_background_02 }}>
							<CustomText weight="bold" style={{ ...styles.modalTitle, color: theme.text_17 }}>
								{t('security_setting_screen_message_09')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_10')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_11')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_12')}
							</CustomText>
							<CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
								{t('security_setting_screen_message_13')}
							</CustomText>

							<div style={styles.modalButtons}>
								<button
									style={styles.cancelButton}
									onClick={() => setDeleteModalVisible(false)}
								>
									<CustomText style={{ ...styles.cancelButtonText, color: theme.label_strong }}>
										{t('security_setting_screen_message_14')}
									</CustomText>
								</button>
								<button
									style={styles.confirmButton}
									onClick={handleQssClearPress}
								>
									<CustomText style={{ ...styles.confirmButtonText, color: theme.text_17 }}>
										{t('security_setting_screen_message_15')}
									</CustomText>
								</button>
							</div>
						</div>
					</div>
				)
			}
			{
				showPinCodeAuth && (
					<div style={styles.modalBackground}>
						<PinCodeScreen onSuccess={handleQssPasswordAuthSuccess} unlock={false} />
					</div>
				)
			}
		</div >
	)
}

export default QssSettingWalletAddressScreen
